<div class="whats-new">
  @switch (state().status) {
    @case ('loading') {
      <div class="skeleton skeleton--image"></div>

      <div class="whats-new__head whats-new__head--skeleton">
        <span class="skeleton skeleton--eyebrow"></span>
        <span class="skeleton skeleton--title"></span>
      </div>

      <div
        class="whats-new__content whats-new__content--skeleton"
        aria-hidden="true"
        whats-new__image-placeholder
      >
        @for (row of skeletonRows; track row) {
          <div class="whats-new__item">
            <span class="skeleton skeleton--heading"></span>
            <span class="skeleton skeleton--line"></span>
            <span class="skeleton skeleton--line skeleton--line-short"></span>
          </div>
        }
      </div>

      <span class="sr-only" role="status" aria-live="polite">
        Loading the latest updates
      </span>
    }

    @case ('error') {
      <div class="whats-new__center">
        <mat-icon class="whats-new__error-icon" [svgIcon]="'error'"></mat-icon>
        <p>Sorry, we couldn't load the latest updates right now.</p>
        <sqep-button
          (buttonClick)="close()"
          buttonCaption="Close"
          buttonTheme="sqep-button-error"
        />
      </div>
    }

    @case ('loaded') {
      @let data = loadedData();

      @if (data.imageUrl) {
        <img class="whats-new__image" [src]="data.imageUrl" alt="whats-new" />
      }

      <div class="whats-new__head">
        <p class="whats-new__eyebrow">What's new</p>
        <h2 class="whats-new__title" mat-dialog-title>
          {{ data.title || 'Release notes' }}
        </h2>
      </div>

      <mat-dialog-content class="whats-new__content">
        @for (section of data.sections; track section.heading) {
          @if (section.heading) {
            <div class="whats-new__item">
              <h3 class="whats-new__heading">{{ section.heading }}</h3>
              <p class="whats-new__body">{{ section.body }}</p>
            </div>
          }
        } @empty {
          <div class="whats-new__item">
            <h3 class="whats-new__heading">Release updates</h3>
            <p class="whats-new__body">Check back soon</p>
          </div>
        }
      </mat-dialog-content>

      <mat-dialog-actions class="whats-new__actions" align="end">
        <sqep-button
          (buttonClick)="viewMore()"
          buttonCaption="View more"
          buttonTheme="sqep-button-secondary"
        />
        <sqep-button
          (buttonClick)="dismiss('got-it')"
          buttonCaption="Got it"
          buttonTheme="sqep-button-primary"
        />
      </mat-dialog-actions>
    }
  }
</div>
